export { generateEditorDocumentMetadata } from './generateEditorDocumentMetadata';
